<template>
  <el-container class="padding_leftRight">
    <el-button type="primary" @click="dialogFormVisible = true">{{
    VApprovalButton
    }}</el-button>

    <el-dialog :title="title" :visible.sync="dialogFormVisible" append-to-body>
      <el-form :model="approval" label-width="auto" v-loading="approvalloading" :rules="confirmRules"
        ref="confirmModel">
        <el-form-item :label="isConfirmComponent?'确认情况：':'核验结果：'" prop="approveStatus">
          <el-radio-group v-model="approval.approveStatus" @change="changeApprovalStatusHandle" class="approval_radio">
            <el-radio v-if="!isConfirmComponent" label="PASSED">通过{{passedTips!=''?'('+passedTips+')':''}}</el-radio>
            <el-radio v-if="!isConfirmComponent" label="NOPASSED">不通过{{noPassedTips!=''?'('+noPassedTips+')':''}}</el-radio>
            <el-radio v-if="isConfirmComponent" label="PASSED">确认接受</el-radio>
            <el-radio v-if="isConfirmComponent" label="NOPASSED">确认不接受</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="isConfirmComponent?'请填写原因：':'核验意见：'" :required="approval.approveStatus == 'NOPASSED'" prop="approveResult">
          <el-input v-model="approval.approveResult" type="textarea" autocomplete="off" maxlength="500"></el-input>
        </el-form-item>
        <img v-if="showImg" class="beseImg" :src="'data:image/gif;base64,'+imgBase64" alt="" />
        <el-form-item :label="'上传附件：'" prop="approveResult" v-if="!isConfirmComponent">
          <el-upload :on-success="uploadSuccess" :on-error="uploadError" :on-change="onChange"
            :before-upload="beforeUpload" class="upload-approval" style="text-align: right" ref="upload"
            :data="uploadData" multiple name="file" :action="getApprovalUploadFileUrl()" :auto-upload="false"
            :accept="fileFilters">
            <el-button slot="trigger" size="mini" type="primary" :title="'支持附件类型：' + fileFilters">添加</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="showConfirm" type="primary" :loading="VLoading" @click="showCover">{{ verSingCa }}</el-button>

        <el-button v-if="!showConfirm" type="primary" :loading="VLoading" @click="submitApprovalHandle">{{
        VConfirmButton }}</el-button>

        <el-button @click="cancelButHandle" :disabled="approvalloading">取消</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>
<script>
import { Loading } from "element-ui";

export default {
  name: "approval",
  props: {
      //当前确认信息组件使用
      isConfirmComponent:{
          type: Boolean,
          default: false,
      },
    //通过旁边的提示：通过（xxxx）
    passedTips: {
      type: String,
      default: "",
    },
    //不通过旁边的提示：通过（xxxx）
    noPassedTips: {
      type: String,
      default: "",
    },
    //用于封装组件的参数传递
    title: {
      type: String,
      default: "核验",
    },
    sid: {
      // 被核验对象主键ID
      type: String,
      required: true,
    },
    itemId: {
      // 审批备案项ID
      type: String,
      required: true,
    },
    url: {
      //提交核验的Url
      type: String,
      required: true,
    },
    VApprovalButton: {
      type: String,
      default: "核验",
    },
    checkids: {
      type: [Object, Array],
    },
    nochecktypes: {
      type: Array,
    },
    callback: {
      //提交核验的
      type: Function,
      required: true,
    },
    passedFlag: {
      // 确认通过前方法处理标志  isCheck:需要判断  checkPassed:通过
      type: String,
      default: "checkPassed",
    },
  },
  data() {
    //data是一个函数，用于维护每个组件使用对象的独立拷贝
    return {
      approvalRequestStatus:false,//核验接口是否请求成功
      approvalloading: false,
      dialogFormVisible: false,
      VConfirmButton: "核验",
      verSingCa: "核验",
      showConfirm: false,
      imgBase64: '',
      showImg: false,
      attachmentId: '12313',
      VLoading: false,
      approval: {
        approveStatus: "PASSED",
        approveResult: this.isConfirmComponent?"确认接受":"核验通过",
        itemId: this.itemId,
        approveObjectId: this.sid,
      },
      formLabelWidth: "120px",
      confirmRules: {
        approveStatus: [
          { required: true, message: "请选择确认结果", trigger: "blur" },
        ],
        //confirmReason: [{ required: true, message: "请填写原因"}]
        approveResult: [
          {
            trigger: "blur",
          },
        ],
      },
      fileFilters: "", //文件类型限制
      uploadLoadingInstance: null, //上传加载
      uploadData: {}, //上传数据
      fileList: [],
      uploadSuccessTotal: 0, //上传文件个数
      caVerParameter: false,//是否需要ca签章核验
    };
  },
  watch: {
    dialogFormVisible: function () {
      this.dialogFormVisible == true &&
        this.passedFlag == "isCheck" &&
        this.$emit("getPassedFlag");

      if (this.dialogFormVisible) {
        this.showConfirm = this.caVerParameter
      } else {
        this.showConfirm = false;
        this.showImg = false;
        this.imgBase64 = '';
      }
    }
  },
  methods: {
    getApprovalUploadFileUrl: function () {
      var context = '/zfcg/';
      var url = '/govp/verificationAttach/batchUpload?_csrf=' + getXsrfTokenCookieValue();
      if (location.pathname !== context) {

        return location.pathname.replace(context, '') + url;
      }
      return url;
    },
    //供父组件调用方法，触发CA签章
    showCover() {
      ExClose(0);
      setSealKeyword(' ');
      addUploadFileParams([{ "objectId": this.sid }]);
      setUploadAddress('/govp/verificationCa/save');
      setUploadSuccessReload(false);
      setVerSignSuccessCallBack(this.call);
      window.caApp = this;
      if (window.caApp.$loading === undefined) {
        Vue.prototype.$loading = this.loading.service
      }
      this.$ajax.get(process.env.API_HOST + "signature/getCurrentUserCookie").then((res) => {
        if (res && res.status == 200) {
          var resData = res.data.data;
          SetValue("SET_CURRENT_COOKIE", "Cookie:" + resData.cookieName + "=" + resData.cookieValue, "", "", "");
        }
      })
      if (getSealKeyword() == '') {
        return this.$message.warning("请先设置要签章的关键字")
      }
      //
      window.caFileLoading = Loading.service({
        body: true,
        lock: true,
        fullscreen: true,
        text: '签章文件加载中',
        background: 'rgba(15, 26, 43, .6)'
      });
      //加载原始pdf
      let fileUrl = window.location.origin + '/zfcg/static/verSignPdf/VerificationDocuments.pdf';
      console.info(fileUrl);
      LoadFile(fileUrl, 'loadFileCompleteSelf', '', "");
    },
    call(data) {
      if (data.success) {
        this.attachmentId = data.data.attachmentId;
        let params = new URLSearchParams();
        params.append("attachmentId", this.attachmentId);
        this.$ajax.get(process.env.API_HOST + 'verificationCa/getVerificationImg', { params: params }).then((res) => {
          if (res.data.success) {
            this.imgBase64 = res.data.data;
            this.showConfirm = false;
            this.showImg = true;
          } else {
            this.$message({ message: '签章显示异常', type: 'warning' })
          }
        })
      }
    },
    submitApprovalHandle: function () {
      if (this.showImg) {
        this.$ajax.post(process.env.API_HOST + 'verificationCa/update', { "attachmentId": this.attachmentId, "objectId": this.approval.itemId }).then((res) => {
          if (res.data.success) {
            this.$message({ message: '更新签章文件成功', type: 'warning' })
          } else {
            this.$message({ message: '文件更新异常', type: 'warning' })
          }
        })
      }
      //提交核验的方法
      this.$refs.confirmModel.validate((valid) => {
        if (valid) {

            if (this.fileList.length > 0) {
                if(!this.uploadData.itemId && this.itemId){
                    this.uploadData.itemId = this.itemId
                }
                if(!this.uploadData.recordObjectId && this.sid){
                    this.uploadData.recordObjectId = this.sid
                }

                this.uploadLoadingInstance = Loading.service({
                    body: true,
                    lock: true,
                    fullscreen: true,
                    text: '文件上传中',
                    background: 'rgba(15, 26, 43, .6)',
                })
                this.$refs.upload.submit()
            }else{
                this.handleCheckRequest()
            }




        } else {
          this.$message({ message: "请检查核验信息", type: "warning" });
        }
      });
    },
    cancelButHandle: function () {
      this.dialogFormVisible = false;
      this.showConfirm = false;
      this.showImg = false;
      this.imgBase64 = '';
    },
    handleCheckRequest:function(){
        if (
            (this.approval.approveStatus == "PASSED" &&
                this.passedFlag == "checkPassed") ||
            this.approval.approveStatus == "NOPASSED") {
            this.changeConfirmButton(true, "已提交");
            if (this.checkids) {
                //如果存在校验信息ID,则走校验方法，否则走正常请求
                this.checkRequst();
            } else {
                this.noCheckRequst();
            }
        } else {
            this.dialogFormVisible = false;
            this.$emit("unpassedCloseCallback");
        }
    }  ,
    noCheckRequst() {
      this.approvalloading = true;
      this.$ajax.post(this.url, this.approval).then((res) => {
        this.dialogFormVisible = false;
        this.changeConfirmButton(false, "核验");
        //res.data.code==-1 是没有权限，如果不加这个条件，会导致页面先提示核验成功，然后再跳转没有权限
        if (res && res.status == 200) {
          this.approvalloading = false;
          if (res.data.data || res.data.success) {
              this.approvalRequestStatus = true;
              this.requestSuccessAction(true, "核验成功");
          } else {
            this.$message({
              message: res.data.message,
              type: "warning",
            });
            this.callback(this.approvalRequestStatus,this.approval.approveStatus);
          }
        } else {
          this.approvalloading = false;
          this.$message({
            message: "核验失败",
            type: "warning",
          });
        }
      });
    },
    checkRequst() {
      this.approvalloading = true;

      this.$ajax
        .checkPost(
          this.url,
          this.approval,
          {},
          this.checkids,
          this.nochecktypes
        )
        .then((res) => {
          this.dialogFormVisible = false;
          this.changeConfirmButton(false, "核验");
          //res.data.code==-1 是没有权限，如果不加这个条件，会导致页面先提示核验成功，然后再跳转没有权限
          if (res && res.status == 200) {
            this.approvalloading = false;
            if (res.data.data || res.data.success) {
                this.approvalRequestStatus = true;
                this.requestSuccessAction(true, "核验成功");
            } else {
              this.$message({
                message: res.data.message,
                type: "warning",
              });
                this.callback(this.approvalRequestStatus,this.approval.approveStatus);
            }
          } else {
            this.approvalloading = false;
            this.$message({
              message: "核验失败",
              type: "warning",
            });
          }
        })
        .catch((err) => {
          this.approvalloading = false;
          this.changeConfirmButton(false, "核验");
          this.$message({
            message: err,
            type: "warning",
          });
        });
    },
    changeConfirmButton: function (VLoading, VConfirmButton) {
      this.VLoading = VLoading;
      this.VConfirmButton = VConfirmButton;
    },
    changeApprovalStatusHandle: function () {
        if(this.isConfirmComponent){
            if (this.approval.approveStatus == "PASSED") {
                this.approval.approveResult = "确认接受";
            } else {
                this.approval.approveResult = "确认不接受";
            }
            return
        }
      //改变核验状态选择的事件
      if (this.approval.approveStatus == "PASSED") {
        this.approval.approveResult = "核验通过";
      } else {
        this.approval.approveResult = "核验不通过";
      }
    },
   uploadSuccess: function (response, file, fileList) {
       if (this.uploadLoadingInstance != null) {
           this.uploadLoadingInstance.close()
       }
       if(response.success && response.success===true && file.status==='success'){
           console.log('上传成功：response',response,'file',file,'fileList',fileList)
           this.uploadSuccessTotal++
           if (this.uploadSuccessTotal == fileList.length) {
               //开始核验
               this.handleCheckRequest()
           }
       }else{
           this.uploadError(response,file,fileList);
       }
   },
   uploadError: function (response, file, fileList) {
       if (this.uploadLoadingInstance != null) {
           this.uploadLoadingInstance.close()
       }
       file.status = 'ready';//待上传状态
       console.log('上传失败：response',response,'file',file,'fileList',fileList)
       this.$message.error('文件上传失败，请重试：' + response.message)

   },
    requestSuccessAction: function (success, message) {
      this.$message({
        message: this.isConfirmComponent?"确认完成":"核验完成",
        type: "success",
      });
      if(success && this.fileList.length > 0){
          let params = new URLSearchParams();
          params.append("recordObjectId", this.uploadData.recordObjectId);
          params.append("itemId", this.uploadData.itemId);
          params.append("configId",this.uploadData.configId);
          this.$ajax.get(process.env.API_HOST + 'verificationAttach/updateBelongId',{params:params}).then((res) =>{
          })
      }
      this.callback(this.approvalRequestStatus,this.approval.approveStatus);
    },
    onChange: function (file, fileList) {
      this.fileList = fileList;
    },
    beforeUpload: function (file) {
      this.uploadData.fileName = file.name;
      this.uploadSuccessTotal = 0;
        this.uploadData.itemId = this.itemId
    },
  },
  mounted() {

  },
  created() {
    this.$ajax.get(process.env.API_HOST + 'verificationCa/getVerParameter', {}).then((res) => {
      if (res.data.success) {
        this.showConfirm = res.data.data;
        this.caVerParameter = res.data.data;
        if (this.showConfirm) {
          this.VConfirmButton = '确认';
        }
      } else {
        this.$message({ message: '请检查签章配置信息', type: 'warning' })
      }
    })
    //获取附件配置信息
    this.$ajax
      .get("/govp/verificationAttach/listTypedAttachments", {})
      .then((res) => {
        if (res.data.success && res.data.data.types.length > 0) {
          res.data = res.data.data;
          this.uploadData.chunk = 0;
          this.uploadData.chunks = 1;
          this.uploadData.configId = res.data.types[0].configId;
          this.uploadData.attachName = res.data.types[0].attachType;
          this.uploadData.belongId = "";
          this.uploadData.itemId = this.itemId;
          this.uploadData.resumableUpload = false;
          this.uploadData.recordObjectId = this.sid;

          if (res.data.types[0].fileFilters != null) {
            let fileFilterArray = res.data.types[0].fileFilters.split(",");
            let fileFilterAlls = "";
            for (let i = 0; i < fileFilterArray.length; i++) {
              fileFilterAlls += "," + "." + fileFilterArray[i];
            }
            this.fileFilters = fileFilterAlls.substring(1);
          }
        } else {
          this.$message({ message: "请检查核验附件配置信息", type: "warning" });
          location.reload();
        }
      });
  },
};
</script>
<style >
.upload-approval .el-upload__input {
  display: none !important;
}

.upload-approval ul.el-upload-list.el-upload-list--text {
  text-align: left !important;
}

.beseImg {
  width: 100px;
  height: 52px;
  opacity: 0.6;
  margin-left: 300px;
  margin-top: 10px;
  position: relative;
  top: -74px;
  left: 326px;
}
</style>



// WEBPACK FOOTER //
// src/components/approval.vue